import { ShareNote } from "@/modules/inbound-wizard/components/consult-with-medical-supervisor/share-note"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"
import { useSharedMedicalRecordNoteStore } from "@/modules/patients/stores/useSharedMedicalRecordNoteStore"

const SharedMedicalRecordNote = () => {
  const patientId = usePatientParam()
  const sharedNote = useSharedMedicalRecordNoteStore((state) => state.notesByPatientId[patientId])

  if (!sharedNote) return null

  return <ShareNote content={sharedNote} />
}

export { SharedMedicalRecordNote }
